export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14627.8ae6c676.jpg";